export default __webpack_public_path__ + "static/media/arrow-back.d6a6ffee.svg";